import { jsxs as c, jsx as r } from "react/jsx-runtime";
import { DayPicker as m } from "./daypicker.js";
import { DatePickerButton as f } from "./datepicker.js";
import { DateRangePicker as y } from "./dateRangePicker.js";
import { useState as p } from "react";
import { Box as n } from "@mui/material";
const u = ({ selectedDate: a, onChange: i }) => {
  const [e, s] = p(a), o = (t) => {
    t !== void 0 && (s(t), i(t));
  };
  return /* @__PURE__ */ c(n, { pb: 3, children: [
    /* @__PURE__ */ r(f, { selectedDate: e, onChange: o }),
    /* @__PURE__ */ r(n, { sx: { display: "flex", justifyContent: "center" }, children: /* @__PURE__ */ r(m, { outerDate: e, selectedDate: e, onChange: o }) })
  ] });
};
export {
  f as DatePickerButton,
  y as DateRangePicker,
  u as DayAndDatePicker,
  m as DayPicker
};
//# sourceMappingURL=index.js.map
